import { mapActions } from 'vuex';

import Events from '_utils/events';
import { _DELETE_SUPERVISOR_ } from './SupervisorModel';

export default {
  name: 'supervisor-actions',
  data() {
    return {
      selectSupervisor: null,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert', 'deleteSupervisor']),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.deleteSupervisor(this.selectSupervisor)
        .then(() => {
          this.close();
          Events.$emit('update:pagination_supervisor_list', false);
          this.$router.push('/admin/supervisores/lista/1');
          this.activeAlert({
            message: 'Supervisor deletado com sucesso',
            theme: 'success',
          });
        })
        .catch(error =>
          this.activeAlert({ message: error.message, theme: 'danger' })
        );
    },
  },
  mounted() {
    Events.$on(_DELETE_SUPERVISOR_, supervisor => {
      this.setToggle({ type: 'confirm_modal', bool: true });
      this.selectSupervisor = supervisor.id;
    });
  },
  destroyed() {
    Events.$off(_DELETE_SUPERVISOR_);
  },
};
